import ModuleHeader from './ModuleHeader';

export default ModuleHeader;
